import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import ScrollableAnchor from 'react-scrollable-anchor';

import './Testimonials.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class SliderTestimonials extends Component {

  render() {
    var settings = {
      accessibility: false,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 740,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    const { data } = this.props;
    return (
      <Slider {...settings}>
        {
          data.map((el,i) => (
            <div key={i}>
              <div className="slide">
                <div className="text">
                  <p className="name">{el.nombre}</p>
                  <p className="description">{el.testimonio}</p>
                </div>
              </div>
            </div>
          ))
        }
      </Slider>
    );
  }
}

class Testimonials extends Component {

  constructor(props) {
    super(props);
    this.state = {
      year:(new Date().getFullYear() - 1988),
      testimonials: [],
    }
  }

  _getTestimonials = () => {
    let url = "http://www.usaproductos.com/api/get-testimonios.php";
    fetch(url)
      .then(response => response.json())
      .then(data => {
        this.setState({ testimonials: data });
      });
  }

  componentDidMount() {
    this._getTestimonials();
  }

  render() {
    const { testimonials, year } = this.state;
    return (
      <ScrollableAnchor id={'testimonials'}>
        <section className="testimonials">
          <div className="stripes">
            <span></span>
            <span></span>
          </div>
          <div className="container-lg center">
            <h1 className="title">{year} años de experiencia</h1>
            <div className="text">
              <p>Compromiso, seriedad y responsabilidad <br/> es lo que nos sigue destacando hoy en día.</p>
            </div>
            <div className="slider-testimonials">
              <SliderTestimonials data={testimonials} />
              <div className="link-exp">
                <Link to="/agregar-testimonio" target="_blank">
                  Envianos tu experiencia
                </Link>
              </div>
            </div>
          </div>
        </section>
        </ ScrollableAnchor>
    )
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/Home/Testimonials/Testimonials.js